import { ENV_DEVELOPMENT, ENV_LOCAL } from "toolkit/environment";

export const appBarColoursByEnvironment: { [key: string]: string } = {
  [ENV_DEVELOPMENT]: "#f44336",
  [ENV_LOCAL]: "#009688",
};
